<template>
  <div class="">

      <div class="modal fade" id="modal-edit-order-items" data-backdrop="static" focus="true" data-keyboard="false" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">
                  Edit Order Items
              </h4>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="closeModal"></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="form-group row">
                   <div class="col-md-6">
                        <label for="rep" class="col-sm-auto col-form-label fw-bold">Order Total</label>
                        <div class="col-sm-auto">
                          <span class="form-control-plaintext" id="rep">{{ orderEdit.total_cost | currency }}</span>
                        </div>
                        <label for="multiShip" class="col-sm-auto col-form-label fw-bold">Split Shipments</label>
                            <div class="col-sm-auto">
                                <span v-if="!orderEdit.multi_ship">
                                    Single &nbsp <i type="button" role="button" class="fa fa-toggle-off" aria-hidden="true" @click="toggleSplitShipments"></i>
                                </span>
                                <span v-else>Split &nbsp <i type="button" role="button" class="fa fa-toggle-on text-success" aria-hidden="true" @click="toggleSplitShipments"></i></span>
                            </div>
                           <!--  <i type="button" role="button" class="fa fa-toggle-off" aria-hidden="true" @click="toggleSplitShipments"></i></span>
                        <span v-else  class="fw-bold">Split Shipments: &nbsp <i type="button" role="button" class="fa fa-toggle-on text-success" aria-hidden="true" @click="toggleSplitShipments"></i></span> -->
            

                      </div>
                      <div class="col-md-6">
                        <label for="shipOne" class="col-sm-auto col-form-label fw-bold">Ship Date</label>
                        <div class="col-sm-auto">
                            <input type="date" class="form-control" id="shipOne" v-model="orderEdit.ship_one_date" :min="min_ship_date" :max="max_ship_date">
                        </div>
                        <label v-if="orderEdit.multi_ship" for="shipTwo" class="col-sm-auto col-form-label fw-bold">Ship Date Two</label>
                        <div v-if="orderEdit.multi_ship" class="col-sm-auto">
                            <input type="date" class="form-control" id="shipTwo" v-model="orderEdit.ship_two_date" :min="min_ship_date" :max="max_ship_date">
                        </div>




                        <!-- <label for="shipdateone" class="col-sm-auto col-form-label fw-bold">Close Date</label>
                        <div class="col-sm-auto">
                          <input type="text" readonly class="form-control-plaintext" id="shipdateone" v-model="orderEdit.closed_at">
                        </div>
                 
                        <label for="hubspotID" class="col-sm-auto col-form-label fw-bold">Hubspot Deal</label>
                        <div class="col-sm-auto">
                          <input type="text" readonly class="form-control-plaintext" id="hubspotID" v-model="orderEdit.hubspot_id">
                        </div>

                        <label for="hubspotStatus" class="col-sm-auto col-form-label fw-bold">Hubspot Status</label>
                      <div class="col-sm-auto">
                        <input type="text" readonly class="form-control-plaintext" id="hubspotStatus" v-model="orderEdit.hubspot_status">
                      </div> -->

                      </div>
                    </div>
                    

                </div>
                <hr> 
                <div class="row" v-for="(val, key, index) in orderEdit.items">
                
                    <div class="form-group row justify-content-between mb-2" :style="!orderEdit.multi_ship ? 'padding-left:50px;padding-right:90px;' : 'padding-right:50px;'">
                        <div class="col-md-2" style="max-width:100px;">



                            <div class="position-relative order-img-col"><img class="img-thumbnail" :alt="val.name" :src="val.image_url" crossorigin="anonymous" @error="val.image_url='/imgs/doomswell-placeholder.png'"/> 
                                            <span v-if="val.preorder" class="position-absolute bottom-0 start-50 translate-middle badge rounded-pill bg-success">
                                                preorder
                                            </span>
                                        </div>






                        </div>
                        <div class="col-md-5">
                            <label for="name" class="col-sm-auto col-form-label fw-bold"></label>
                            <div class="col-sm-auto ">
                              <input type="text" readonly class="form-control-plaintext fw-bold text-start" id="name" v-model="val.name">
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label for="sku" class="col-sm-auto col-form-label fw-bold"></label>
                            <div class="col-sm-auto">
                              <input type="text" readonly class="form-control-plaintext fw-bold text-end" id="sku" v-model="val.sku">
                            </div>
                        </div>
                        
                    </div>
                    <div class="form-group row">
                        <div class="row d-flex justify-content-evenly">
                            <div v-if="!orderEdit.multi_ship"class="col-md-2 text-center" style="max-width:100px;">
                                <label for="shipOneQuantity" class="form-label text-muted mb-0"><small>Quantity</small></label>
                                <input v-model="val.ship_one.quantity" type="number" class="form-control text-center" id="shipOneQuantity" name="ship1" min="0" :max="val.ship_one.max_orderable_quantity" @change="recalculateValues(val)">
                            </div>
                            <div v-if="orderEdit.multi_ship" class="col-md-2 text-center" style="max-width:100px;">
                                <label for="shipOneQuantity" class="form-label text-muted mb-0"><small>Ship 1</small></label>
                                <input v-model="val.ship_one.quantity" type="number" class="form-control text-center" id="shipOneQuantity" name="ship1" min="0" :max="val.ship_one.max_orderable_quantity" @change="recalculateValues(val)">
                            </div>
                            <div v-if="orderEdit.multi_ship" class="col-md-2 text-center" style="max-width:100px;">
                                <label for="shipTwoQuantity" class="form-label text-muted mb-0"><small>Ship 2</small></label>
                                <input v-model="val.ship_two.quantity" type="number" class="form-control text-center" id="shipTwoQuantity" name="ship2" min="0" :max="val.ship_two.max_orderable_quantity" @change="recalculateValues(val)">
                            </div>
                            <div v-if="orderEdit.multi_ship" class="col-md-2 text-center"  style="max-width:125px;">
                                <label for="totalQuantity" class="form-label text-muted mb-0"><small>Total Quantity</small></label>
                                <input type="number" readonly class="form-control text-center" min="0.01" step="0.01" id="totalQuantity" :value="val.total_quantity" >
                            </div>
                            <div class="col-md-2 text-center" style="max-width:100px;">
                                <label for="selectedProductWholesale" class="form-label text-muted mb-0"><small>Wholesale</small></label>
                                <input v-if="!val.margin_override" type="text" readonly class="form-control-plaintext text-center" id="selectedProductWholesale" :value="val.unit_price|currency">
                                <input v-else v-model="val.unit_price" type="number" step="0.01" class="form-control text-center" id="selectedProductWholesale" @change="recalculateValues(val)">
                            </div>
                            <div class="col-md-2 text-center" style="max-width:100px;">
                                <label for="selectedProductWholesaleMargin" class="form-label text-muted mb-0"><small>Margin</small></label>
                                <input type="text" readonly class="form-control-plaintext text-center" :class="val.margin_override ? 'text-decoration-line-through text-muted' : ''" id="selectedProductWholesaleMargin" :value="marginDiscount">
                            </div>
                            <div class="col-md-2 text-center" style="max-width:100px;">
                                <label for="selectedProductRetail" class="form-label text-muted mb-0"><small>MAP</small></label>
                                <input type="text" readonly class="form-control-plaintext text-center" id="selectedProductRetail" :value="val.retail_price|currency">
                            </div>
                            <div class="col-md-2 text-center" style="max-width:100px;">
                                <label for="totalCost" class="form-label text-muted mb-0"><small class="fw-bold">Item Total</small></label>
                                <input type="text" readonly class="form-control-plaintext text-center fw-bold" id="totalCost" :value="val.total_cost|currency">
                            </div>
                            <div class="row d-flex justify-content-between align-items-end mt-3">
          
                                <div class="col-md-auto" :class="orderEdit.multi_ship ? '' : 'offset-sm-1 px-1 mx-5'">
                                    <p  class="text-muted small mb-1" v-if="val.quantities">Available: {{ val.quantities.quantity_available }}</p>
                                    <p class="text-muted small mb-0" v-if="val.quantities">Incoming: {{ val.quantities.quantity_incoming }}</p>
                                    <p class="text-muted small mb-0" v-else>Save draft to see quantities</p>
                                </div>
                                 <div class="col-md-auto">
                                    <p v-if="!val.margin_override" class="text-muted text-end mb-1"  v-tooltip:bottom="'Set Custom Price'">
                                        Ignore Margin &nbsp <i type="button" role="button" class="fa fa-toggle-off" aria-hidden="true" @click="val.margin_override = !val.margin_override"></i>
                                    </p>
                                    <p v-else class="text-muted text-end mb-1"  v-tooltip:bottom="'Restore Default Price (On Save)'">
                                        Ignore Margin &nbsp <i type="button" role="button" class="fa fa-toggle-on text-success" aria-hidden="true" @click="val.margin_override = !val.margin_override"></i>
                                    </p>
                                </div>
                                <div class="col-md-auto">
                                    <p v-if="!val.preorder" class="text-muted text-end mb-1">
                                        Allow Preorder &nbsp <i type="button" role="button" class="fa fa-toggle-off" aria-hidden="true" @click="togglePreorder(val)"></i>
                                    </p>
                                    <p v-else class="text-muted text-end mb-1">
                                        Allow Preorder &nbsp <i type="button" role="button" class="fa fa-toggle-on text-success" aria-hidden="true" @click="togglePreorder(val)"></i>
                                    </p>
                                    <p class="text-muted text-end mb-0">
                                        Remove Item &nbsp <i type="button" role="button" class="fa fa-trash text-danger" aria-hidden="true" @click="deleteItem(val.id)"></i>
                                    </p>
                                </div>
                           
                            </div>
                        </div>
                    </div>
                    <hr v-if="key !== lastItem" class="mt-3" >
                </div>


                <!-- <div class="row justify-content-center" v-if="!loading">
                    <div class="col-md-12">
                        <div class="card mb-2" >
                            <div class="card-header">
                                <span class="lead">Order Details</span>
                            </div>
                            <div class="card-body" style="font-size:.9rem;">
                                <div class="row">
                                    <div class="col-md-3">
                                        <div class="row mb-0">
                                            <label class="col-sm-auto col-form-label fw-bold" for="contactName">Buyer:</label>
                                            <div class="col-sm-auto">
                                                <span id="contactName" class="form-control-plaintext">{{ orderContact.contact_name }}</span>
                                                <span id="company_name" class="form-control-plaintext">{{ orderContact.company_name }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="row mb-0">
                                            <label class="col-sm-3 col-form-label fw-bold" for="email">Email:</label>
                                            <div class="col-sm-9">
                                                <span id="email" class="form-control-plaintext">{{ orderContact.email }}</span>
                                            </div>
                                        </div>
                                        <div class="row mb-0">
                                            <label class="col-sm-3 col-form-label fw-bold" for="email">Phone:</label>
                                            <div class="col-sm-9">
                                                <span id="email" class="form-control-plaintext">{{ orderContact.phone }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="row mb-0">
                                            <label class="col-sm-3 col-form-label fw-bold" for="orderCity">City:</label>
                                            <div class="col-sm-9">
                                                <span id="orderCity" class="form-control-plaintext">{{ orderContact.city }}</span>
                                            </div>
                                        </div>
                                        <div class="row mb-0">
                                            <label class="col-sm-3 col-form-label fw-bold" for="orderState">State:</label>
                                            <div class="col-sm-9">
                                                <span id="orderCity" class="form-control-plaintext">{{ orderContact.state }}</span>
                                                
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="row mb-0">
                                            <label class="col-sm-4 col-form-label fw-bold" for="email">Rep:</label>
                                            <div class="col-sm-8">
                                                <span id="email" class="form-control-plaintext">{{ user.name }}</span>
                                            </div>
                                        </div>
                                        <div class="row mb-0">
                                            <label class="col-sm-4 col-form-label fw-bold" for="email">Order Date:</label>
                                            <div class="col-sm-8">
                                                <span id="email" class="form-control-plaintext">{{ todaysDate }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->




              <!-- {{ orders }} -->
              <!-- <table class="table table-condensed table-hover" style="display:table">
                <thead class="thead-light">
                  <tr>
                    <th scope="col" style="white-space:nowrap;">PO#</th>
                    <th scope="col" style="white-space:nowrap;" class="text-center">Ordered</th>
                    <th scope="col" style="white-space:nowrap;" class="text-center">Received</th>
                    <th scope="col" style="white-space:nowrap;">Arrival Due Date</th>
                  </tr> 
                </thead>
                <tbody>
                  <tr v-for="order in orders">
                    <td>{{ order.po_number }}</td>
                    <td class="text-center">{{ order.quantity_ordered }}</td>
                    <td class="text-center">{{ order.quantity_received }}</td>
                    <td>{{ order.arrival_date | moment }}</td>
                  </tr>
                  <tr>
                    <td><strong>Total</strong></td>
                    <td class="text-center"><strong>{{ totalOrdered }}</strong></td>
                    <td class="text-center"><strong>{{ totalReceived }}</strong></td>
                    <td><span v-if="totalReceived != 0"><strong>Incoming: {{ totalOrdered - totalReceived }}</strong></span></td>
                  </tr>
                </tbody>
              </table>    -->
            </div>
            <!-- Modal Actions -->
            <div class="modal-footer border-none">
                <button type="button" class="btn btn-light" @click="closeModal">
                Close
              </button>
                <button type="button" class="btn btn-light text-white" style="background-color:#ff7a59;"  @click="updateOrder">Save</button>
              
            </div>
          </div>
        </div>
      </div>

      <!-- end of modal -->
  </div>
</template>

<style lang="css">

</style>

<script>
  import moment from 'moment'
  export default {
    // props:['order'],
    props:{
        onSaveCallback: {
        type: Function,
        default: function () {return true;}
      },
      order: {
        type: Object
      }
    },
    data() {
      return {
        orderEdit: [],
        errors: [],
        showing_modal: false,
        min_ship_date: null,
        max_ship_date: null,
        updating: false,
      };
    },
    created() {
      // runs when the component is created
      // this.alias();
      Bus.$on('editOrderItemModalShow', () => {
        this.orderEdit = structuredClone(this.order);
        this.setDefaults();
        this.showModal();
        // this.test();
      });
    },
    mounted() {
      // runs when the element is injected into the browser
    },
    computed: {
      lastItem(){
         return Object.keys(this.orderEdit.items).length-1;
      },
      // sum: function(items, prop){
      //   return items.reduce( function(a, b){
      //     return a + b[prop];
      //   }, 0);
      // },
      // orderedSum(){
      //   return this.sum(this.orders,'quantity_ordered');
      // },
      marginDiscount(){
        if (this.orderEdit.discount_percent == 0)
        {
            return '45%';
        } else {
            return this.orderEdit.discount_percent + '%';
        }
      }
    },
    methods: {
      //   test(){
      //    Swal.fire('Test!', 'Hello test message','success');
      // },
        deleteItem(item_id){
            let objIndex = this.orderEdit.items.findIndex((obj => obj.id == item_id));

          let self = this;
          Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            // icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, remove this item'
          }).then((result) => {
            if (result.value) {
              axios
                .delete('/api/orders/order/' + item_id)
                .then((res) => {
                  Swal.fire(
                    'Deleted!',
                    'The item has been removed.',
                    'success'
                  );
                  this.orderEdit.items.splice( objIndex, 1 );
                  this.recalculateValues(this.orderEdit.items[0]);
                  this.successfulSave();
                  // Bus.$emit('editOrderItems(orderEdit.id)');
                }).catch((error) => {
                  console.log(error);
                  // Bus.$emit('newOacAlert', {text: "Could not remove order", type: 'danger'});
                });
            }
          });
        },
        togglePreorder(item){
            let objIndex = this.orderEdit.items.findIndex((obj => obj.id == item.id));

            this.orderEdit.items[objIndex].preorder = !this.orderEdit.items[objIndex].preorder;

            if(this.orderEdit.items[objIndex].preorder === true)
            {
                this.orderEdit.items[objIndex].ship_one.max_orderable_quantity = null;
                this.orderEdit.items[objIndex].ship_two.max_orderable_quantity = null;
            } else {
                if ((this.orderEdit.items[objIndex].ship_one.quantity + this.orderEdit.items[objIndex].ship_two.quantity) > this.orderEdit.items[objIndex].quantities.quantity_orderable)
                {
                    this.orderEdit.items[objIndex].ship_one.quantity = this.orderEdit.items[objIndex].quantities.quantity_orderable;

                    this.orderEdit.items[objIndex].ship_two.quantity = this.orderEdit.items[objIndex].quantities.quantity_orderable - this.orderEdit.items[objIndex].ship_one.quantity;
                    this.orderEdit.items[objIndex].total_quantity = +this.orderEdit.items[objIndex].ship_one.quantity + +this.orderEdit.items[objIndex].ship_two.quantity;
                }

                // if (this.orderEdit.items[objIndex].ship_two.quantity > (this.orderEdit.items[objIndex].quantities.quantity_orderable + this.orderEdit.items[objIndex].ship_one.quantity))
                // {
                    
                // }

                this.orderEdit.items[objIndex].ship_one.max_orderable_quantity = this.orderEdit.items[objIndex].quantities.quantity_orderable - this.orderEdit.items[objIndex].ship_two.quantity;
                this.orderEdit.items[objIndex].ship_two.max_orderable_quantity = this.orderEdit.items[objIndex].quantities.quantity_orderable - this.orderEdit.items[objIndex].ship_one.quantity;

                this.recalculateValues(this.orderEdit.items[objIndex]);
            }
        },
        recalculateValues(item){
            // console.log(item);
            let objIndex = this.orderEdit.items.findIndex((obj => obj.id == item.id));
            
            // console.log("Before update: ", this.orderEdit.items[objIndex])
            // let id = item.id
            // console.log("Before update: ", this.orderEdit.items);//this.orderEdit.items[id]);
            this.orderEdit.items[objIndex].total_quantity = +item.ship_one.quantity + +item.ship_two.quantity;
            this.orderEdit.items[objIndex].total_cost = (item.ship_one.quantity * item.unit_price) + (item.ship_two.quantity * item.unit_price);
            this.orderEdit.items[objIndex].ship_one.cost = item.ship_one.quantity * item.unit_price;
            this.orderEdit.items[objIndex].ship_two.cost = item.ship_two.quantity * item.unit_price;
            
            if(!this.orderEdit.items[objIndex].preorder )
            {
                this.orderEdit.items[objIndex].ship_one.max_orderable_quantity = item.quantities.quantity_orderable - item.ship_two.quantity;
                this.orderEdit.items[objIndex].ship_two.max_orderable_quantity = item.quantities.quantity_orderable - item.ship_one.quantity;

            }
            
           

            let total = 0;
                this.orderEdit.items.forEach((item) => {
                    total = +item.total_cost + total;
                });

                this.orderEdit.total_cost = +(Math.round(total + "e+2")  + "e-2");
        },
        setDefaults(){
            this.min_ship_date = moment().add(1, 'd').format("YYYY-MM-DD");
            this.max_ship_date = moment().add(1, 'Y').format("YYYY-MM-DD");
        },
        toggleSplitShipments(){
            this.orderEdit.multi_ship = !this.orderEdit.multi_ship;

            if (!this.orderEdit.multi_ship)
            {
                this.orderEdit.ship_two_date = null;
                this.orderEdit.items.forEach((item) => {
                    item.ship_one.quantity = +item.ship_one.quantity + +item.ship_two.quantity;
                    item.ship_two.quantity = 0;
                    item.ship_two.cost = 0;
                    item.ship_two.preorder = false;
                });
            } else {
                if (this.orderEdit.ship_two_date === null)
                {
                    this.orderEdit.ship_two_date = moment().add(1, 'M').format("YYYY-MM-DD");
                }
            }
        },
      closeModal(){
        $('#modal-edit-order-items').modal('hide');
        Bus.$emit('updateOrderItems');
        this.showing_modal = false;
      },
      showModal(){
        $('#modal-edit-order-items').modal('show');
        this.showing_modal = true;
      },
      updateOrder(){
        this.updating = true;
        axios({
          method: 'put',
          url: '/api/orders/order/' + this.orderEdit.id,
          data: this.orderEdit,
        }).then((res)=>{
            this.successfulSave();
            this.updating = false;
            this.closeModal();
            // this.saved = true;
            // Bus.$emit('newOacAlert', {text: 'Thank you for requesting a new feature!', type: 'success'});
        }).catch((error) => {
          console.log(error);
          // this.errors.push({msg: error.response.data.message });
          // Bus.$emit('newOacAlert', {text: error.response.data.message, type: 'danger'});
        });
    },
      successfulSave(){
        this.onSaveCallback();
      },
      
    },
    filters: {
        moment: function (date) {
            return moment(date).format('MMMM Do YYYY');
        }
    },
    watch:{
       orderEdit(val) {
           this.orderEdit.closed_at = this.$options.filters.moment(val);
           // this.orderEdit.total_cost = this.$options.filters.currency(val);
        },
    }
  }
  // Bus.$emit('updateUser');
</script>